import { Avatar, AvatarFallback, AvatarImage } from "@/components/wensity/avatar";
import { useSiteContent } from "@/data/SiteContentContext";

export function TerminalCard() {
  const { site } = useSiteContent();

  const lines = [
    { key: "name", value: site.author.name },
    { key: "roles", value: site.author.roles },
    { key: "stack", value: site.author.stack },
    { key: "where", value: site.author.location },
    { key: "fuel", value: site.author.fuel },
  ] as const;

  return (
    <aside
      className="overflow-hidden rounded-2xl border border-[var(--color-border)] bg-[#0a0c0b] shadow-[0_20px_60px_-30px_rgba(0,0,0,0.8)]"
      aria-label="Terminal intro"
    >
      <div className="flex items-center gap-2 border-b border-[var(--color-border)] px-4 py-3">
        <span className="inline-flex gap-1.5" aria-hidden="true">
          <span className="h-3 w-3 rounded-full bg-[#ff5f57]" />
          <span className="h-3 w-3 rounded-full bg-[#febc2e]" />
          <span className="h-3 w-3 rounded-full bg-[#28c840]" />
        </span>
        <span className="ml-2 truncate font-mono text-xs text-[var(--color-muted)]">{site.email}</span>
      </div>
      <div className="p-4 font-mono text-[13px] leading-7">
        <pre className="whitespace-pre-wrap">
          {lines.map((line) => (
            <span key={line.key} className="block">
              <span className="text-[var(--color-primary)]">{line.key}</span>{" "}
              <span className="text-[var(--color-foreground)]">{line.value}</span>
            </span>
          ))}
          <span className="mt-1 inline-block h-4 w-2 animate-terminal-blink bg-[var(--color-primary)] align-middle" aria-hidden="true" />
        </pre>
      </div>
      <div className="flex items-center gap-4 border-t border-[var(--color-border)] bg-[rgba(20,24,22,0.72)] p-4">
        <Avatar className="h-14 w-14 border border-[var(--color-border)]">
          <AvatarImage src={site.author.image} alt={site.author.name} />
          <AvatarFallback>BW</AvatarFallback>
        </Avatar>
        <div>
          <p className="font-semibold text-[var(--color-foreground)]">{site.author.name}</p>
          <p className="text-sm text-[var(--color-muted)]">{site.author.location}</p>
        </div>
      </div>
    </aside>
  );
}
